import {
  RoomId,
  roomId,
  RoomIsRecording,
  roomIsRecording
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomRecordingSetCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomRecordingSetCmd.validationSchema()
  );

  constructor(readonly value: RoomRecordingSet) {
    JsonSchemaValidator.assert(RoomRecordingSetCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "roomIsRecording"],
      properties: {
        roomId,
        roomIsRecording
      }
    };
  }
}

interface RoomRecordingSet {
  roomId: RoomId;
  roomIsRecording: RoomIsRecording;
}
